import css from 'styled-jsx/css';

export default css`
  .faq-desktop {
    padding: 0 100px;
  }
  .faq {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    color: var(--primary);
    border-top: 0.5px solid var(--card-border-pricing);
    cursor: pointer;
  }
  .basic .pricing-card-title-divider,
  .basic :global(.button) {
    background: var(--basic);
    color: white;
  }

  .plus .pricing-card-title-divider,
  .plus :global(.button) {
    background: var(--plus-color);
    color: white;
  }

  .shopify .pricing-card-title-divider,
  .shopify :global(.button) {
    background: #008060;
    color: white;
  }
  .light .pricing-card-title-divider,
  .light :global(.button) {
    background: var(--info);
    color: white;
  }

  :global(.pricing-card-description) {
    min-height: 120px;
    padding: 10px 20px;
  }
  .section-find-more {
    padding: 20px;
    text-align: center;
  }
  .section-find-more p {
    cursor: pointer;
  }
  @media only screen and (max-width: 460px) {
    :global(.pricing-card-description) {
      min-height: 0px;
    }
  }
  .pricing-card-discount-promo {
    font-size: 18px;
    font-weight: 500;
    text-decoration: line-through;
  }
  .pricing-card-saving-promo {
    font-size: 16px;
    margin-top: 4px;
  }

  .bsocial .pricing-card-title-divider,
  .bsocial :global(.button) {
    background: linear-gradient(to right, var(--accent) 0%, #09a5ec 100%);
    color: white;
  }
  :global(.pricing-card-description) {
    padding: 10px 20px;
  }
  .bsocial-first-block {
    border-right: 1px solid var(--card-border-pricing);
  }
  .tutorial-text p {
    color: var(--primary);
    text-decoration: underline;
    cursor: pointer;
    font-weight: 700;
  }
  :global(.info-activation) {
    padding: 10px 20px 10px;
  }
  :global(.info-activation p) {
    font-size: 12px;
  }
  :global(.info-activation .icon) {
    font-size: 15px;
  }
  :global(.info-activation-text) {
    color: var(--primary);
    background: #33a9f72e;
    border-radius: 5px;
    padding: 4px 6px;
  }
  .description-min {
    min-height: 90px;
  }
  .pricing-card-discount-promo {
    font-size: 18px;
    font-weight: 500;
    text-decoration: line-through;
  }
  .pricing-card-saving-promo {
    font-size: 16px;
    margin-top: 4px;
  }
  .promo-circle {
    border-radius: 50px;
    width: 80px;
    height: 80px;
    right: 18px;
    top: 30px;
    display: flex;
    align-items: center;
    font-size: 10px;
    justify-content: center;
    background: linear-gradient(180deg, #eaff62, #eeff82);
    border: 3px solid #ddfe00;
    box-shadow: 0px 1px 5px rgb(0 0 0 / 40%);
    position: absolute;
    color: black;
    font-weight: 700;
    text-align: center;
    flex-direction: column;
  }
  .card-pricing-sp {
    height: 20px;
  }
  .pricing-card-price-decimal {
    font-size: 26px;
  }
  .pricing-card-most-cashback {
    background: #7fffe1;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 5px 10px;
    box-sizing: border-box;
    border-radius: 2px;
  }
  .pricing-card-cashback-text {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    color: #006855;
    margin-left: 7px;
  }
`;
